/**
 * Title configuration for the dashboard
 * Simple pattern: "$title : $brand" where title matches the page's h1
 * and brand is the white-label company name ("Alli AI" on our own host).
 * The proxy uses the same separator when it rewrites the static <title>.
 */
import { getWhiteLabelConfig } from "~/utils/white-label";

export interface TitleConfig {
  siteName: string;
  separator: string;
}

/**
 * Simplified title configuration
 * All pages use the same pattern: "$title : $brand"
 */
export const titleConfig: TitleConfig = {
  siteName: getWhiteLabelConfig().company_name,
  separator: ":",
};
